import { Fragment, useEffect, useState, useRef, useCallback } from 'react';
import { connect } from 'react-redux';
import 'react-quill/dist/quill.snow.css';

import { changeInboxTabAction, activeUserChatWindowAction } from '../../store/inbox';
import { bookingUserChatAction } from '../../store/chat';
import { getInboxService } from '../../services/inboxService';
import ChatUserList from './ChatUserList';
import AboutActiveChatUser from './AboutActiveChatUser';
import ChatBoxLayout from './ChatBoxLayout';
import UserImg from '../../assets/img/user.png'
import { IoChevronBackOutline } from 'react-icons/io5';

const ChatView = (props) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1399);
  const [isOpen, setIsOpen] = useState(window.innerWidth < 1399);

  // Resize handler - only update on breakpoint change
  const handleResize = useCallback(() => {
    const isNowMobile = window.innerWidth < 1399;
    // Only update if mobile state changed
    setIsMobile(prev => {
      if (prev !== isNowMobile) {
        setIsOpen(isNowMobile); // Close/open sidebar when switching breakpoints
        return isNowMobile;
      }
      return prev;
    });
  }, []);

  // Attach debounced resize listener
  useEffect(() => {
    let frameId = null;

    const onResize = () => {
      if (frameId) return;
      frameId = requestAnimationFrame(() => {
        handleResize();
        frameId = null;
      });
    };

    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      if (frameId) cancelAnimationFrame(frameId);
    };
  }, [handleResize]);

  const toggleSidebar = (val) => {
    if (isMobile) setIsOpen(val);
  };

  // Opened from the booking page's "Message User" (bookingUserChat = { _id, name, profileImage }).
  // Prefer the user's existing conversation, so the chat carries its groupId exactly as if it had
  // been clicked in the list. With none, open an empty 1:1 window: the socket's sendMessage looks up
  // the group by the two user ids, and creates it on the first message.
  useEffect(() => {
    const target = props.bookingUserChat;
    if (!target?._id) return;
    // Consume it once, so later visits to the inbox don't reopen this chat.
    props.bookingUserChatAction('');

    const sameUser = u => String(u?._id ?? u) === String(target._id);
    const targetUser = { _id: target._id, name: target.name, profileImage: target.profileImage };

    // The API's search is an unescaped `^name` regex on the user's name, so search by the first
    // word only, stripped of regex characters, and match the result by id.
    const word = (target.name || '').trim().split(/\s+/)[0].replace(/[.*+?^${}()|[\]\\]/g, '');
    const lookup = word
      ? getInboxService(`?pageNo=1&limit=50&chatType=1&search=${encodeURIComponent(word)}`)
          .then(res => (res?.data?.responseData?.result || []).find(item => item.type === 1 && item.userId?.some(sameUser)))
          .catch(() => null)
      : Promise.resolve(null);

    lookup.then(existing => {
      props.activeUserChatWindowAction(existing
        // ChatBoxLayout treats userId[0] as the contact; keep the target first.
        ? { ...existing, userId: [existing.userId.find(sameUser), ...existing.userId.filter(u => !sameUser(u))] }
        : { type: 1, _id: target._id, userId: [targetUser] });
      toggleSidebar(false);
    });
  }, [props.bookingUserChat]);

  const renderChatBoxContent = () => {
    if (props?.activeUserChatWindow?.userId) {
      return (
        <>
          <ChatBoxLayout toggleSidebar={toggleSidebar} />
          <AboutActiveChatUser />
        </>
      );
    } else {
      return (
        <div
          className="chat_box_layout"
          style={{ width: `calc(100% - ${isMobile ? '0px' :'295px'})`, marginRight: 0 }}
        >
            <div className='chat_box__header'>
                <IoChevronBackOutline  onClick={() => toggleSidebar(false)} color='#fffff' size={24}/>
            </div>
          <div className="chat_welcom_inner">
            <img
              className="d-none d-sm-inline"
              src={props.userProfile?.profileImage || UserImg}
              alt={props.userProfile?.name}
            />
            <h6>Welcome back {props.userProfile?.name}</h6>
          </div>
        </div>
      );
    }
  };

  return (
    <div className="chat_view_page">
      {isMobile ? (
        isOpen ? (
          <ChatUserList toggleSidebar={toggleSidebar} />
        ) : (
          renderChatBoxContent()
        )
      ) : (
        <>
          <ChatUserList toggleSidebar={toggleSidebar} />
          {renderChatBoxContent()}
        </>
      )}
    </div>
  );
};



const mapStateToProps = state => {
    let { userProfile } = state.user;
    let { inboxTab, activeUserChatWindow } = state.inbox;
    let { bookingUserChat } = state.chat;
    return {
        userProfile,
        inboxTab,
        activeUserChatWindow,
        bookingUserChat
    };
}

const mapDispatchToProps = dispatch => ({
    changeInboxTabAction: params => dispatch(changeInboxTabAction(params)),
    activeUserChatWindowAction: params => dispatch(activeUserChatWindowAction(params)),
    bookingUserChatAction: params => dispatch(bookingUserChatAction(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatView);

